module.exports = __webpack_public_path__ + "img/ic_check_r_off.202f76c1.svg";